import React from 'react';
import { CalendarRange } from 'lucide-react';
import DatePicker from 'components/ui/DatePicker';
import { hoyCR } from 'lib/fechaCR';
import { diasEntre, periodoAtajo, fechaCorta } from 'lib/auditoria';

export const ATAJOS_HISTORIAL = [
  { id: '7', label: '7 días' },
  { id: '30', label: '30 días' },
  { id: '90', label: '90 días' },
  { id: 'anio', label: 'Año' },
];

export const ATAJOS_REPORTE = [
  { id: 'mes_anterior', label: 'Último mes' },
  { id: '12m', label: 'Últimos 12 meses' },
  { id: 'anio', label: 'Año' },
];

export const periodoInicial = (atajo) => ({ atajo, ...periodoAtajo(atajo, hoyCR()) });

export const textoPeriodo = ({ desde, hasta }) => {
  const n = diasEntre(desde, hasta).length;
  return `Del ${fechaCorta(desde)} al ${fechaCorta(hasta)} (${n} ${n === 1 ? 'día' : 'días'})`;
};

// Período explícito con atajos. value = { atajo, desde, hasta }.
// "custom" (o tocar una fecha) muestra los dos calendarios.
export default function PeriodoSelector({ value, onChange, atajos = ATAJOS_HISTORIAL }) {
  const hoy = hoyCR();
  const elegir = (id) => {
    if (id === 'custom') return onChange({ ...value, atajo: 'custom' });
    const p = periodoAtajo(id, hoy);
    if (p) onChange({ atajo: id, ...p });
  };
  const mostrarFechas = value.atajo === 'custom' || !atajos.some((a) => a.id === value.atajo);

  return (
    <div className="rounded-xl border border-border bg-card p-3">
      <div className="mb-2 flex items-center gap-1.5 text-xs font-bold uppercase tracking-wide text-muted-foreground">
        <CalendarRange size={13} /> Período
      </div>
      <div className="flex flex-wrap gap-1.5" role="group" aria-label="Atajos de período">
        {atajos.map((a) => {
          const activo = value.atajo === a.id;
          return (
            <button key={a.id} type="button" onClick={() => elegir(a.id)} aria-pressed={activo}
              className={`h-9 rounded-full border px-3 text-sm font-medium transition ${
                activo ? 'border-primary bg-primary/10 text-primary' : 'border-border bg-white text-foreground hover:border-muted-foreground'
              }`}>
              {a.label}
            </button>
          );
        })}
        {!atajos.some((a) => a.id === 'custom') && (
          <button type="button" onClick={() => elegir('custom')} aria-pressed={value.atajo === 'custom'}
            className={`h-9 rounded-full border px-3 text-sm font-medium transition ${
              value.atajo === 'custom' ? 'border-primary bg-primary/10 text-primary' : 'border-border bg-white text-foreground hover:border-muted-foreground'
            }`}>
            Fechas
          </button>
        )}
      </div>
      {mostrarFechas && (
        <div className="mt-2.5 flex flex-wrap items-end gap-2">
          <label className="flex flex-col gap-1 text-xs font-medium text-muted-foreground">
            Desde
            <DatePicker value={value.desde} max={value.hasta || hoy} size="sm" className="w-auto"
              onChange={(iso) => iso && onChange({ ...value, atajo: 'custom', desde: iso })} />
          </label>
          <label className="flex flex-col gap-1 text-xs font-medium text-muted-foreground">
            Hasta
            <DatePicker value={value.hasta} min={value.desde} max={hoy} size="sm" className="w-auto"
              onChange={(iso) => iso && onChange({ ...value, atajo: 'custom', hasta: iso })} />
          </label>
        </div>
      )}
      <p className="mt-2 text-xs font-medium text-muted-foreground" data-testid="periodo-texto">{textoPeriodo(value)}</p>
    </div>
  );
}
